<script>
  export let heading, body, className
</script>

<div class='h-12 w-14 md:h-14 md:w-14 flex flex-col text-center justify-center text-gray-800 dark:text-gray-200 p-1 {className}'>
  <span class='label-heading md:scale-100 text-tiny leading-3' data-heading={heading}></span>
  <span class='label-body font-bold text-2xl' data-body={body}></span>
</div>

<style lang="postcss">
  .label-heading::before {
    content: attr(data-heading);
  }

  .label-body::before {
    content: attr(data-body);
  }
</style>
